module.exports = __webpack_public_path__ + "static/media/email.75dac837.png";